import { createSlice, type PayloadAction } from "@reduxjs/toolkit/react";

export interface CommonSliceState {
  lang?: string;
  env?: string;
  defaultEnv?: string;
  isInMaintenance?: boolean;
  satisfactionGoBack?: boolean;
}

const initialState: CommonSliceState = {
  lang: undefined,
  env: 'fr',
  defaultEnv: 'fr',
  isInMaintenance: false,
  satisfactionGoBack: false,
};

export const commonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {
    setLanguage(state, payload: PayloadAction<string>) {
      state.lang = payload.payload;
    },
    setDefaultEnv(state, payload: PayloadAction<string>) {
      state.defaultEnv = payload.payload;
    },
    setIsInMaintenance(state, payload: PayloadAction<boolean>) {
      state.isInMaintenance = payload.payload;
    },
    setSatisfactionGoBack(state, payload: PayloadAction<boolean>) {
      state.satisfactionGoBack = payload.payload;
    }
  },
});

export const { setLanguage, setDefaultEnv, setIsInMaintenance, setSatisfactionGoBack } = commonSlice.actions;
